import React from 'react';
import styled from 'styled-components';
import { Heading3, P, Link, Strong, Margin } from '@ovotech/element-v5';
import useWindowDimensions from '@/src/utils/hooks/useWindowDimensions';
import { SmartMeterImage } from './SmartMeterImage';
import {
  RewardsCard,
  RewardsCardContent,
  RewardsCardTextContent,
  RewardsCardActions,
  RewardsCardImageContainer,
} from './RewardsCard';
import { useAnalytics } from '@ovotech/ui-tools';
import { ALL_REWARDS_PAGE } from '@/src/constants/analytics';

const SubHeading = styled(P)`
  color: ${({ theme }) => theme.colors.brand.ovo};
`;

const Heading = styled(Heading3)`
  color: ${({ theme }) => theme.colors.brand.midnight};
`;

type SmartMeterProps = {
  analyticsProps: Record<string, unknown>;
};

export const SmartMeter = ({ analyticsProps }: SmartMeterProps) => {
  const { isMobile } = useWindowDimensions();
  const { dispatch } = useAnalytics();

  const onGetASmartMeterClick = () => {
    dispatch({
      name: ALL_REWARDS_PAGE.SMART_METER.CLICKED_GET_SMART_METER,
      type: 'click',
      properties: analyticsProps,
    });
  };

  const onWhyGetASmartMeterClick = () =>
    dispatch({
      name: ALL_REWARDS_PAGE.SMART_METER.CLICKED_WHY_SMART_METER,
      type: 'click',
      properties: analyticsProps,
    });

  return (
    <RewardsCard>
      <RewardsCardContent>
        <RewardsCardTextContent>
          <SubHeading size="md">
            <Strong>Upgrade at no extra cost</Strong>
          </SubHeading>
          <Heading>Get a free smart meter</Heading>

          <Margin top={4}>
            <P>It sends readings automatically, so you don't have to.</P>
          </Margin>

          <RewardsCardActions>
            <Link
              variant="surface"
              onClick={onGetASmartMeterClick}
              href={
                'https://smart-booking.ovoenergy.com/getting-started?utm_medium=smartbanner-rewards&utm_source=websitebanner&utm_campaign=beyond_rewards_smart_button'
              }
            >
              Get a Smart Meter
            </Link>
            <Link
              href="https://www.ovoenergy.com/smart-meters"
              variant="outline"
              inline
              opensInNewWindow
              onClick={onWhyGetASmartMeterClick}
            >
              Why get a smart meter?
            </Link>
          </RewardsCardActions>
        </RewardsCardTextContent>

        <RewardsCardImageContainer>
          <SmartMeterImage size={isMobile ? 80 : 160} />
        </RewardsCardImageContainer>
      </RewardsCardContent>
    </RewardsCard>
  );
};
